'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const LargeNotesIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="LargeNotesIcon">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" height="24" width="24">
        <g id="chat-bubble-notes--chat-bubble-notesList-task">
          <path
            id="Union"
            fill="#8fbffa"
            fillRule="evenodd"
            d="M2 1H1v19h4.25v3.7944l1.52605 -0.9439L11.3843 20H23V1H2Z"
            clipRule="evenodd"
            strokeWidth="1"
          ></path>
          <path
            id="Union_2"
            fill="#2859c5"
            fillRule="evenodd"
            d="M6 7h2v2H6V7Zm0 5h2v2H6v-2Zm12 -3h-8V7h8v2Zm-8 5h8v-2h-8v2Z"
            clipRule="evenodd"
            strokeWidth="1"
          ></path>
        </g>
      </svg>
    </SvgIcon>
  )
}

LargeNotesIcon.propTypes = {
  sx: PropTypes.object
}
